import validate from "/usr/src/app/content/n3-promos-b311e686-fcb5-4558-b778-3a2ca94d4b39/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-b311e686-fcb5-4558-b778-3a2ca94d4b39/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}